module.exports = __webpack_public_path__ + "img/icon-interpersonal-tab.73821626.png";